import { Switch, SwitchProps } from 'antd';
import React, { FC } from 'react';

const DgSwitch: FC<SwitchProps> = ({ ...props }) => {
	return <Switch {...props} />;
};

export default DgSwitch;
